import React, { useMemo } from 'react';
import Joyride, { CallBackProps, STATUS, EVENTS } from 'react-joyride';
import { useTour } from '@/context/TourContext';
import { TourTooltip } from './TourTooltip';

export const TourRunner: React.FC = () => {
  const { activeTour, isRunning, completeTour, skipTour, stopTour } = useTour();

  const styles = useMemo(() => ({
    options: {
      zIndex: 10000,
      primaryColor: 'hsl(var(--primary))',
      textColor: 'hsl(var(--foreground))',
      backgroundColor: 'hsl(var(--background))',
      arrowColor: 'hsl(var(--background))',
      overlayColor: 'rgba(0, 0, 0, 0.5)',
    },
    tooltip: {
      borderRadius: 8,
      padding: 20,
    },
    tooltipTitle: {
      fontSize: '1.25rem',
      fontWeight: 600,
      marginBottom: 8,
    },
    tooltipContent: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
    },
    buttonNext: {
      backgroundColor: 'hsl(var(--primary))',
      borderRadius: 6,
      padding: '8px 16px',
    },
    buttonBack: {
      color: 'hsl(var(--muted-foreground))',
    },
    buttonSkip: {
      color: 'hsl(var(--muted-foreground))',
    },
  }), []);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, type, index } = data;

    // Tour completado
    if (status === STATUS.FINISHED && activeTour) {
      completeTour(activeTour.id);
    }

    // Tour pulado
    if (status === STATUS.SKIPPED && activeTour) {
      skipTour(activeTour.id);
    }

    // Tour fechado antes do fim com logging detalhado
    if (type === EVENTS.TARGET_NOT_FOUND || status === STATUS.ERROR) {
      console.error('Tour error:', {
        type,
        status,
        tourId: activeTour?.id,
        stepIndex: index,
        target: activeTour?.steps[index]?.target,
        message: 'Target não encontrado ou erro ocorreu'
      });
      stopTour();
    }
  };

  if (!activeTour || !isRunning) return null;

  return (
    <Joyride
      steps={activeTour.steps}
      run={isRunning}
      continuous={activeTour.continuous}
      showProgress={activeTour.show_progress}
      showSkipButton={activeTour.show_skip_button}
      scrollToFirstStep
      disableScrolling={false}
      spotlightClicks
      tooltipComponent={TourTooltip}
      styles={styles}
      locale={{
        back: 'Voltar',
        close: 'Fechar',
        last: 'Concluir',
        next: 'Próximo',
        skip: 'Pular',
      }}
      callback={handleJoyrideCallback}
    />
  );
};
